import { Component, Input } from '@angular/core';
import { InfoGroupComponent } from '@tecalisdev/infinity';
import { UuidDisplayComponent } from '../uuid-display/uuid-display.component';

@Component({
	selector: 'app-uuid-flexible-display',
	imports: [InfoGroupComponent, UuidDisplayComponent],
	templateUrl: './uuid-flexible-display.component.html',
	styleUrl: './uuid-flexible-display.component.scss',
})
export class UuidFlexibleDisplayComponent {
	@Input() uuid: string = '';
	@Input() label?: string;
}
